class GsgDemoReviews extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.resize?.disconnect();
    this.abort = new AbortController();
    const track = this.querySelector('[data-demo-review-track]');
    const previous = this.querySelector('[data-demo-prev]');
    const next = this.querySelector('[data-demo-next]');
    if (!track || !previous || !next) return;
    const options = { signal: this.abort.signal };
    const sync = () => {
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const step = direction => {
      const distance = (track.firstElementChild?.getBoundingClientRect().width ?? track.clientWidth) + 16;
      track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    previous.addEventListener('click', () => step(-1), options);
    next.addEventListener('click', () => step(1), options);
    track.addEventListener('scroll', sync, { ...options, passive: true });
    this.resize = new ResizeObserver(sync);
    this.resize.observe(track);
    sync();
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.resize?.disconnect();
  }
}
if (!customElements.get('gsg-demo-reviews')) customElements.define('gsg-demo-reviews', GsgDemoReviews);
